module.exports = __webpack_public_path__ + "img/131.2226fdf8.jpg";